@if (filterForm) {
<div class="link-workday-project-container">
    <div class="workday-header">
        <h3>Link Outcome(s)</h3>
    </div>
    <div class="filter-panel">
        <div class="filters" [formGroup]="filterForm">
            <div class="freetext-filter-panel">
                <input class="freetext-filter" placeholder="Search by Outcome ID Outcome Details"
                    formControlName="searchTerm">
            </div>
        </div>
    </div>
    @if (pagedLinkableOutcomes?.length) {
        <div class="results-panel" matSort matSortActive="createdOn" matSortDirection="desc"
            (matSortChange)="sortData($event)">
            <div class="results-header">
                <div>Link Outcome</div>
                <div>Outcome ID</div>
                <div>Goal Metric</div>
                <div>Total Progress</div>
                <div>Record ID</div>
                <div>Record Type</div>
                <div>Hub Record Name</div>
                <div>Outcome Statement</div>
            </div>
            <div class="results-grid">
                @for (linkableOutcome of pagedLinkableOutcomes; track linkableOutcome.projectOutcome.outcome.outcomeId) {
                <div class="result-row" [ngClass]="{'linked': isLinked(linkableOutcome)}">
                    <div>
                        @if(isLinked(linkableOutcome)) {
                            <div style="color: #49a942; font-weight: 500;">
                                Linked
                                <img src="assets/images/checkmark.png" style="width: 20px; margin-left: 5px">
                            </div>

                        }
                        @else {
                            <button (click)="addLink(linkableOutcome)">
                                <div>Link</div>
                                <img src="assets/images/icons/link_icon_white.png">
                            </button>
                        }
                    </div>
                    <div>{{linkableOutcome.projectOutcome.outcome.uniqueId}}</div>
                    <div>{{linkableOutcome.projectOutcome.outcome.outcomeMetric.name}}</div>
                    <div>
                        {{linkableOutcome.projectOutcome.outcomeStatistics.totalProgress | number:'1.0-0'}}
                        {{linkableOutcome.projectOutcome.outcome.outcomeUnit.name }}
                    </div>
                    <div>{{linkableOutcome.projectId}}</div>
                    <div>{{linkableOutcome.project.projectType.name}}</div>
                    <div>{{linkableOutcome.project.name}}</div>
                    <div>{{linkableOutcome.projectOutcome.statement}}</div>
                </div>
                }
            </div>
        </div>
    }
    @else {
        <div>
            <div class="alert alert-info alert-styled-left shadow-0 ng-star-inserted" style="margin-top: 40px;">
                There are no matching Outcomes to link to.
            </div>
        </div>
    }
    @if (searchResult?.results.length === 0) {
    <div class="no-results-panel">
        <div class="alert alert-info alert-styled-left">
            No Matching Outcomes Found
        </div>
    </div>
    }
    <div class="pager-panel">
        @if (pagedLinkableOutcomes?.length) {
        <app-hub-paginator [currentPage]="currentPage" [totalItems]="linkableOutcomes.length"
            [totalPages]="totalPages" (pageRequested)="pageRequested($event)">
        </app-hub-paginator>
        }
    </div>
    <div class="finance-projects-footer">
        <button (click)="close()">
            <div>Done</div>
        </button>
    </div>
</div>
}
